"use client"
import ButtonWithArrow from "@/ui/common/bit/ButtonWithArrow"
import { mediaQueries } from "@/ui/theme/mediaQueries"
import styled from "@emotion/styled"

export const StyledButtonWithArrow = styled(ButtonWithArrow)`
  ${mediaQueries.tabletDown} {
    margin-bottom: 80px;
  }
`
